import { render, staticRenderFns } from "./FormTitle.vue?vue&type=template&id=5b2d5078&"
import script from "./FormTitle.vue?vue&type=script&lang=js&"
export * from "./FormTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports